module.exports = __webpack_public_path__ + "img/ps-table.84e4a79d.svg";